export default __webpack_public_path__ + "static/media/work-order-white-db.dcf0f6e5.svg";